module.exports = __webpack_public_path__ + "img/DNADamage-BRCA_GSE176078.b1884814.png";